import { Route } from '@angular/router';

import { authGuard } from './core/guards';

export const appRoutes: Route[] = [
  {
    path: '',
    loadChildren: () => import('./pages/base/base.routes'),
    canActivate: [authGuard],
  },
  {
    path: 'sign-up',
    loadComponent: () => import('./pages/registration/registration'),
    data: { animation: 'sign-up' },
  },
  {
    path: 'sign-in',
    loadComponent: () => import('./pages/authorization/authorization'),
    data: { animation: 'sign-in' },
  },
];
